<template>
  <div v-if="data">
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <keep-alive>
      <view-shipping-request-details :shipping-request="data"></view-shipping-request-details>
    </keep-alive>
  </div>
</template>

<script>
import ViewShippingRequestDetails from "@/modules/commonModule/components/viewShippingRequestDetails/Main";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapMutations } = createNamespacedHelpers("shippers");

export default {
  name: "shipping-application-details",
  components: { ViewShippingRequestDetails },
  props: { id: String },
  data() {
    return {
      data: null,
      isLoading: true
    };
  },
  computed: {
    ...mapGetters({
      getShippingRequestByID: "getShippingRequestByID",
      getApprovedShippingRequestById: "getApprovedShippingRequestById"
    })
  },
  mounted() {
    this.data =
      this.getShippingRequestByID(this.$route.params.id)[0] ||
      this.getShippingRequestByID(this.id)[0];
    this.isLoading = false;
  }
};
</script>
